import { FeiKeyDef, FunctionCoreEngine, WidgetLine, WizConstants } from "@wizeoo/akm-compute-lib";
import { IWidget } from "../../../../manager/widgets/i-widget";
import { Model } from "../../../../model/model";
import { ICellRendererParams } from "ag-grid-community";
import { ViewData } from "../../../../model/view.data";
import { AttachmentService } from "../../../../command/core/attachment/attachment.service";
import { WIZ_BOOLEAN, WizBooleanUtils, WizFileUtils } from "@wizeoo/akm-core-lib";
import { StyleEngine } from "../../../../manager/workingdata/style.engine";
import { FeiEngine, WizColDef } from '../../../../manager/workingdata/fei.engine';
import { ConnectVO } from "../../../../vo/core/connect.vo";
import { FreedataValueVO } from "../../../../vo/core/freedatavalue.vo";
import { FreedataArgsVO } from "../../../../vo/core/freedataargs.vo";
import { WIDGET_GLOBAL_KIND } from "../../../../model/enums";
import { Measure } from "@wizeoo/akm-message-lib";
import { ICellRendererFunc } from 'ag-grid-community';
import { scenCellConfig } from "../../../../manager/scenarii/scenario.engine";
import { AggregateEngine } from "../../../../manager/computer/aggregate-engine";
import { forkJoin, Observable } from "rxjs";

export class GridAccessors  {

  protected _model: Model = null;
  public get model(): Model {
    return this._model as Model;
  }

  constructor(model: Model) {
    this._model = model;
  }

  /**
   * détermine le nbr max de lignes possible
   * @param params 
   * @returns 
   */
  public static getMaxLine(params: ICellRendererParams): number {
    let rowHeight: number = params.node.rowHeight;
    let maxLine: number = Math.floor(rowHeight/15);
    return maxLine;
  }

  /** rendu agGrid par défaut, Max 3 lignes, centré vertical & ellipsis */
  public CELL_DEFAULT_RENDERER(params: ICellRendererParams): string {
    let render = `<div class="wiz-cell-container">
                    <span
                      class="wiz-cell-text" style="-webkit-line-clamp: ${GridAccessors.getMaxLine(params)};"
                    >
                      ${ params.valueFormatted || ''  }
                    </span>
                  </div>`; 
    return render;
  }




  /**
   * rendu des mesures de type WORKFLOW
   * @param event 
   * @returns 
   */
  public workflowCellRender(params: ICellRendererParams): string {

    let render = `<div class="wiz-cell-container">`;
    let content: string = '';
    if(params.valueFormatted) {
      try {
        let smallMess: any = JSON.parse(params.valueFormatted);
        
        if(!!smallMess.image) {
          const attachmentBytes: string = AttachmentService.getInstance().getAttachmentOrError(smallMess.image, true);
          if (attachmentBytes === ViewData.ATTACHMENT_ERROR) { // la pièce est introuvable

          }  else if (attachmentBytes) {
            render += `<div style="height:100%;aspect-ratio:1"><img class="wiz-cell-image" blobid='${smallMess.image}' src='${WizFileUtils.imageFromBinaryString(attachmentBytes)}'></div>`;
          }
        }
      
      
        if(smallMess.icon) {
          render += '<i class="material-icons" style="padding-right:5px;">' + smallMess.icon + '</i>';
        }

        if(smallMess.keys) {
          content = smallMess.keys.join(" - ");
        }

        if(!!smallMess.media) {
          let fileStr: string = smallMess.media.shortFileName + '<i class="wiz-icon- cell-edit-icon wiz-cell-file">download</i>';
          content = [content, fileStr].join('<br>');
        }

        render += `<span class="wiz-cell-text" style="-webkit-line-clamp: ${GridAccessors.getMaxLine(params)};"
              >${content}</span>`;    

      } catch(e: any)
      {
        console.log('workflowCellRender', e , params);
      }
    }
    let showEdit: boolean = ((params as any).colDef.widget as IWidget).checkBeforeEdit(params, false, true, true);
    if(showEdit) { 
      render += '<i class="wiz-icon- cell-edit-icon">edit</i>';
    }
    render += '</div>';

    return render;
  }

  /**
   * rendu fichier
   * @param event 
   * @returns 
   */
  public fileCellRender(params: ICellRendererParams): string {
    
    let render = `<div class="wiz-cell-container">`;
    render += `<span class="wiz-cell-text" style="-webkit-line-clamp: ${GridAccessors.getMaxLine(params)};"
              >${params.valueFormatted}</span>`;    
    
    if(!!params.valueFormatted) {
      // let showEdit: boolean = ((params as any).colDef.widget as IWidget).checkBeforeEdit(params, false, true, true);
      // if(showEdit) { 
        render += '<i class="wiz-icon- cell-edit-icon wiz-cell-file">download</i>';
      // }
    }
   
    render += '</div>';
    return render;

  }



  /** renderer des cellules éditables, hors cbx */
  public CELL_EDITABLE_RENDERER: ICellRendererFunc = (params: any) => {
    
    // contrôle de visibilité
    const model: Model = params.colDef.widget.model; // prise du modèle
    let line: WidgetLine = params.data; // l'entrée de ligne  // freedatavalueVO
    let hideMe: boolean = false; // masquer les checkBoxes qui n'existent pas
    if(params.colDef.widget.toolMode === FeiEngine.TOOL_MODE_LIST) {
      hideMe = false; // pas de colonnes en mode pop sur mesure List
    } 
    else if(!line.isTotalLine && params.colDef.widget?.columnAggregate) {
      let realLinePack: WidgetLine[] = []; // le pool qu'on va gérer, si on est en mode pivot
      let col: any = params.columnApi.getColumn(params.colDef)?.parent;
      if(!!line.linesByColumn?.has(col)) { // on est en pivot, on prend seulement les lignes éligibles
        realLinePack = line.linesByColumn.get(col);
      } 
      if(realLinePack.length < 1) {
        hideMe = true;
      }
    }
    
    if(hideMe) {
      return `<div></div>`;
    }
    
    
    // configuration scenars
    let scenConf: scenCellConfig = model.scenarioEngine.baseScenDetection(params);
    // rendre éditable (ou pas). Par défaut, ici, on est éditable
    // pas d'édition possible sur les filterKeys en row sur les lignes simples dans le cas d'une consolidation
    let showEdit: boolean = (params.colDef.widget as IWidget).checkBeforeEdit(params, false, true, true);
    


    let render = `<div class="wiz-cell-container">`;

    if(scenConf.isScen && scenConf.hasDefault) { // main + un / des scen
      render += model.scenarioEngine.writeScenPart(scenConf.color, true);
    } else if(scenConf.isScen) { // un scenar
      render += model.scenarioEngine.writeScenPart(scenConf.color, false);
    }

    render += `<span class="wiz-cell-text" style="-webkit-line-clamp: ${GridAccessors.getMaxLine(params)};"
              >${params.valueFormatted || '' }</span>`;


    if(showEdit) { 
      render += '<i class="wiz-icon- cell-edit-icon">edit</i>';
    }   
    render += '</div>';

    return render;
  }


  /**
   * accesseur pour le formatage des valeurs dans un filter.pop.grid
   * @param params le param de la cellule
   * @returns rendu formaté
   */
  public fdArgFormattedAccessor(params: any): any {
      let model: Model = params.colDef.widget.model;
      const result = model.formatEngine.applyFormat(params.value, params.colDef.datakind, params.colDef.dataformat, null); // et formater
      // console.log('fd format', params.value, result);
      return result;
  }

  /**
   * injection du padding sur colonnes fusionnées en mode pmdEx
   * @param params 
   * @returns 
   */
  public CELL_UNIQUECOLUMN_RENDERER(params: ICellRendererParams): any {
    
    let level: number = (params.data as WidgetLine).subTotalLevel;
    let pad: number = (level -1)*10;
    let padStyle: string = 'style="padding-left:'+ pad +'px"'
    
    let result: string = `<div ${padStyle}>${params.valueFormatted}</div>`;
     
    // console.log('CELL_UNIQUECOLUMN_RENDERER', params.valueFormatted);
    return result;
  }

  /** Gestion de rendu des images au sein du grid */
  public attachmentCellRender(event: ICellRendererParams): string {
        // console.log('_handleAttachmentCellRender', event.value, event.valueFormatted);
        if (!event.value) {
          let result = `<div></div>`;
          return result;
        }

        // gestion des erreurs de calcul sur mesure de type image
        if(event.value === FunctionCoreEngine.FUNCTION_NOT_APPLICABLE 
        || event.value === FunctionCoreEngine.FUNCTION_ERROR 
        ) {
            return `<div></div>`;
        }

        // console.log('feiAttach', event);
        // const attachmentBlobId: string = event.valueFormatted?.replace(ViewData.KEY_SEPARATOR, '');
        const vals = event.valueFormatted?.replace(ViewData.KEY_SEPARATOR, '').split(',');
        const attachmentBlobId: string = vals ? vals[0] : null; // plusieurs images possibles si pivot
        const attachmentBytes: string = AttachmentService.getInstance().getAttachmentOrError(attachmentBlobId, true);
        if (attachmentBytes === ViewData.ATTACHMENT_ERROR) { // la pièce est introuvable
        return `<div></div>`; // id='${attachmentBlobId}'
        }
        else if (attachmentBytes) {
         
        let cssStyle: string = (event.colDef as WizColDef).wcio?.sty;
        let injectClass: string = 'voidme';
        try {
          if(!!cssStyle) {
            injectClass = cssStyle;
          }
        } catch(e: any) {
          console.log('cssrender', e, cssStyle);
        }  

        let result = `<div class="wiz-cell-image-container"><img class="wiz-cell-image ${injectClass}" blobid='${attachmentBlobId}' src='${WizFileUtils.imageFromBinaryString(attachmentBytes)}'></div>`;
        if (vals?.length > 1) { // pusieurs images
            result += '...';
        }

        // let showEdit: boolean = ((event as any).colDef.widget as IWidget).checkBeforeEdit(event, false, true, true);
        // if(showEdit) {
        //     result += '<i class="wiz-icon- cell-edit-icon">edit</i>';
        // }
        
        return result;
        }
        // console.log('feiAttach not now', event, attachmentBlobId);
        AttachmentService.getInstance()
        .downloadAttachmentForWidget(attachmentBlobId, true)
        .subscribe(() => event.api.refreshCells({ force: true, rowNodes: [event.node], columns: [event.column] }));
        return `<div class="fa-xl" style="margin: 5px"><i class="fa-spin fa-solid fa-spinner"></i></div>`;
  }

  /** rendu couleur / colorPicker */
  public colorRenderer(event: ICellRendererParams): string {
    // console.log('colorRenderer', event.value, event.valueFormatted);
    let vals:string[] = null;
    
    let showEdit: boolean = ((event as any).colDef.widget as IWidget).checkBeforeEdit(event, false, true, true);

    let result = `<div>`;
    // une valeur ou éditable, on va dessiner la zone
    if (!!event.value || showEdit) {
      result = `<div class="wiz-cell-color">`;
      
      if (showEdit) {
        result += ` <span class="cell-edit-icon"`;
      } else {
        result += ` <span`;
      }

      result += ` style="border-radius: 20px; border-style: solid; display: inline-flex;
      border-width: 1px; width:20px; height:20px;`;

      let colorCode: string = StyleEngine.STYLE_DEFAULT_WIDGET_BACKGROUND_COLOR;
      if (!!event.value) {
        vals = event.valueFormatted.split(WizConstants.STYLE_ELEMENT_SEPARATOR);
        colorCode = vals[0];
      }
      result += ` background-color:${colorCode};`;

      if (showEdit) {
        result += ` cursor: pointer;`;
      }
      result += `"></span>`;
      
      if (vals?.length > 1) { // pusieurs images
        let otherVals: string[] = vals.slice(1,6);
        // result += `<div style="display: flex; flex-direction: row">`;
        otherVals.forEach(str => {
          result += `<span style="border-radius: 6px; border-style: solid; display: inline-flex;
          border-width: 1px; width:6px; height:6px; background-color:${str};"></span>`;
        });
        // result += `</div>`
        // result += '...';
      }

    } 
    result += `</div>`;
    return result;
  }

  /** Gestion de rendu des images au sein du grid */
  public imageCellRender(event: ICellRendererParams): string {
    // console.log('imageCellRender', event.value, event.valueFormatted);
    if (!event.value) {
      return `<div></div>`;
    }

    // gestion des erreurs de calcul sur mesure de type image
    if(event.value === FunctionCoreEngine.FUNCTION_NOT_APPLICABLE || event.value === FunctionCoreEngine.FUNCTION_ERROR) {
        return `<div></div>`;
    }

    let result = `<img style="padding: 2px; max-width:100%; max-height:100%;" src='${event.value}'>`;
    return result;
  }


  /** Gestion de rendu des hyperlink au sein du grid */
  public hyperlinkCellRender(event: ICellRendererParams): string {
    // console.log('hyperlinkCellRender', event.value, event.valueFormatted);
    if (!event.value) {
      return `<div></div>`;
    }

    // gestion des erreurs de calcul sur mesure de type image
    if(event.value === FunctionCoreEngine.FUNCTION_NOT_APPLICABLE || event.value === FunctionCoreEngine.FUNCTION_ERROR) {
        return `<div></div>`;
    }

    let linkUrl = '';
    let linkLabel = '';
    const dataParts: string[] = event.value.split(ViewData.KEY_SEPARATOR);
    if(!!dataParts) {
      linkUrl = dataParts[0];
      linkLabel = dataParts.length > 1 ? dataParts[1] : dataParts[0];
    }

    let result = `<a href="${linkUrl}" target="_blank">${linkLabel}</a>`;
    return result;
  }


 /** Gestion de rendu de type boutons au sein d'un grid (connect) */
 public actionCellRender(event: ICellRendererParams): string {

    const connect: ConnectVO = event.value;
    if (!connect) {
      return `<div></div>`;
    }
    
    // le renderer est polymorphe, peut contenir un FDV ou une WidgetLine
    if(event.data instanceof FreedataValueVO) {
      let model: Model = ((event as any).colDef.widget as IWidget).model;
      if(!model.freedataEngine.checkEditAvailable(event)) { // pas éditable
        // console.log('actionCellRender no edit', event.value);
        return `<div></div>`;
      }
    } else { // dans une baseline
      // console.log('actionCellRender no edit', event.value, event.value);
      try {
        let showEdit: boolean = ((event as any).colDef.widget as IWidget).checkBeforeEdit(event, false, true, true);
        if(!showEdit) { // pas éditable
          // console.log('actionCellRender no edit', event);
          return `<div></div>`;
        }
      } catch(e:any) {
        // console.log('bad Action', event);
      }
    }


    const attachmentBlobId: string = connect.icon;
    if(attachmentBlobId) {
      const attachmentBytes: string = AttachmentService.getInstance().getAttachmentOrError(attachmentBlobId, true);
      if (attachmentBytes === ViewData.ATTACHMENT_ERROR) { // la pièce est introuvable
        return `<div></div>`; // id='${attachmentBlobId}'
      }
      else if (attachmentBytes) {
        
        let buttonMode: boolean = false;
        // TODO TODO améliorer, gérer dans le keyFormatter
        if((event?.colDef as WizColDef)?.dataformat) {
          const twoPart: string = (event.colDef as WizColDef).dataformat.split(ViewData.KEY_SEPARATOR)[1];
          if(twoPart === 'BUTTON') {
            buttonMode = true;
          }
        }

        let result;
        if(buttonMode) {
          result = `<div class="wiz-cell-action" style="cursor: pointer; width: 100%;height: 100%;" title='${connect.trsLabel}'>
          <img style="padding: 2px; max-width:100%; max-height:100%; pointer-events: none;" 
          
          src='${WizFileUtils.imageFromBinaryString(attachmentBytes)}'></div>`;
        } else { // rendu complet, bt + label
          result = `<div class="wiz-cell-action" style="cursor: pointer; width: 100%;height: 100%;" title='${connect.trsDescription}'>
          <img style="padding: 2px; max-width:100%; max-height:100%; pointer-events: none;"   
          src='${WizFileUtils.imageFromBinaryString(attachmentBytes)}'>${connect.trsLabel}</div>`;
        }

        return result;
      }
      // console.log('feiAttach not now', event, attachmentBlobId);
      AttachmentService.getInstance()
      .downloadAttachmentForWidget(attachmentBlobId, true)
      .subscribe((e: any) => {
        console.log('back fromAttach',e, attachmentBlobId);
        if(e) {
          // console.log('back fromAttach',e);
          event.api.refreshCells({ force: true, rowNodes: [event.node], columns: [event.column] });
        } else {
          console.log('not found', attachmentBlobId);
          return `<div class="wiz-cell-action" style="cursor: pointer; width: 100%;height: 100%;">${connect.trsLabel}</div>`;
        }
      });
      return `<div class="wiz-cell-action" style="margin: 5px"><i class="fa-spin fa-solid fa-spinner"></i>${connect.trsLabel}</div>`;
    } else { // pas d'icone sur connect
      return `<div class="wiz-cell-action" style="cursor: pointer; width: 100%;height: 100%;">${connect.trsLabel}</div>`;
    }

  }  

  /**
   * accesseur custom pour rendu des actions dans les pivots (baseline ou FDV)
   * @param params la conf d'une cellule de grid. .data contient une WidgetLine ou un FDV
   * @return cnx, un ConnectVO
   */
  public actionAccessor(params: any): any {
  
    const widget: IWidget = params.colDef.widget; // widget
    const colDef: WizColDef = params.colDef; // la colonne
    const model: Model = widget.model; // prise du modèle
    let result: ConnectVO = null;
    if(!model.connectWidgetMap.get(widget)?.has(colDef)) { // pas encore généré
    
      // mode FDV, ou Champ FDV dans baseline
      let fdv: FreedataValueVO = null; // le FDV
      let field : string = null; // le champ utilisé, c'est un type ACTION
      let conf: FreedataArgsVO = null; // le args correspondant, va porter l'action
      let action: string = null; // le code de la fonction connect

      if(widget.widgetGlobalKind === WIDGET_GLOBAL_KIND.FREEDATA) { // c'est un FDV
        fdv = params.data;
        field = params.colDef.fdvfield;
        conf = model.freedataEngine.getArgFromFD(fdv.freeDataCode, field);
        action = conf?.action;
      } else { // c'est une WidgetLine: soit c'est une mesure de type ACTION, soit un args de type ACTION
        try {
          let fkd: FeiKeyDef = params.colDef.fkd;
          if(fkd.isMeasure) { // une mesure
            let meas: Measure = fkd.measure;
            action = meas?.formulaI;
          } else { // un args sur KEY / filterKey
            conf = model.freedataEngine.getArgFromFD(params.colDef.field.split(ViewData.CONTEXT_SEPARATOR)[0], params.colDef.fdvfield);
            action = conf?.action;
          }
        } catch(e:any) {
          console.log('bad Action', e);
        }
      }
      
      if(!!action) { // pas d'action, rien à faire
        result = model.connectMapExt?.get(model.domainCode)?.get(model.businessUnitCode)?.get(action); 
      }

      // mémorisation du résultat pour optim de rendu
      if(!model.connectWidgetMap.has(widget)) {
        model.connectWidgetMap.set(widget, new Map());
      }
      if(!model.connectWidgetMap.get(widget).has(colDef)) {
        model.connectWidgetMap.get(widget).set(colDef, result);
      }
    }

    result = model.connectWidgetMap.get(widget).get(colDef);
    return result;
  }

  /** renderer des groupes */
  public CELL_GROUP_RENDERER: ICellRendererFunc = (params: any) => {

    let line: WidgetLine = params.data; // l'entrée de ligne    
    if(!line.isSubTotalLine) {
      return `<div></div>`;
    }

    let result: string = params.value; // ''; // rendu pour retour
    // console.log('rend', line.key, line.subTotalExpended);

    if(!!line.subTotalExpended) {
      result = `<i class="wiz-icon- cell-group-icon">reduce</i>`;
    } else {
      result = `<i class="wiz-icon- cell-group-icon">creation</i>`;
    }
    
    return result;
  }
    
  /** renderer des cellules en mode pivot.revert */
  public CELL_REVERT_RENDERER: ICellRendererFunc = (params: any) => {
    const model: Model = params.colDef.widget.model; // prise du modèle
    let line: WidgetLine = params.data; // l'entrée de ligne    
    
    let datakind: string = line.fkd.datakind;
    let align: string = model.dataEngine.datakindIsNumeric(datakind) ? 'R': 'L';
    if(!!line.wcio?.heada) {
      align = line.wcio.heada;
    }

    let alignMsg = '';
    
    if(params.colDef?.fkd?.code === ViewData.REVERT_MESURE_COLUMN) { // c'est la 1ère colonne, elle porte le nom des mesures
      
    } else {
      if(align === 'C') {
        alignMsg = ' style="text-align: center" ';
      } else if(align === 'R') {
        alignMsg = ' style="text-align: right" ';
      }
    }

    let result = `<div${alignMsg}>${params.valueFormatted}</div>`

    // console.log('cellRevert', params);

    let scenConf: scenCellConfig = model.scenarioEngine.revertScenDetection(params);
    let terminalDiv: boolean = true; // rajouter une div à la fin, pour les scenars


    if(scenConf.isScen && scenConf.hasDefault) {
      result = model.scenarioEngine.writeScenPart(scenConf.color, true);
      result += `<div style="position: relative; top: -60; width: calc(100% + 5px); height: 100%;">
      <div${alignMsg}> ${params.valueFormatted}</div>`;
    } else if(scenConf.isScen) {
      result = model.scenarioEngine.writeScenPart(scenConf.color, false);
      result += `<div style="position: relative; top: -30; width: calc(100% + 5px); height: 100%;">
      <div${alignMsg}> ${params.valueFormatted}</div>`;

    } else {
      terminalDiv = false;
      result = `<div${alignMsg}>${params.valueFormatted}</div>`
    }

    if(terminalDiv) {
      result += `</div>`;
    }


    return result;
  }



  /** renderer des cellules éditables, hors cbx */
  public CELL_SCEN_EDITABLE_RENDERER: ICellRendererFunc = (params: any) => {
    const model: Model = params.colDef.widget.model; // prise du modèle
    let line: WidgetLine = params.data; // l'entrée de ligne    
    let hideMe: boolean = false; // masquer les checkBoxes qui n'existent pas
    if(params.colDef.widget.toolMode === FeiEngine.TOOL_MODE_LIST) {
      hideMe = false; // pas de colonnes en mode pop sur mesure List
    } 
    else if(!line.isTotalLine && params.colDef.widget?.columnAggregate) {
      let realLinePack: WidgetLine[] = []; // le pool qu'on va gérer, si on est en mode pivot
      let col: any = params.columnApi.getColumn(params.colDef)?.parent;
      if(!!line.linesByColumn?.has(col)) { // on est en pivot, on prend seulement les lignes éligibles
        realLinePack = line.linesByColumn.get(col);
      } 
      if(realLinePack.length < 1) {
        hideMe = true;
      }
      // console.log('checkbox has data', line.key, line.linesByColumn.get(col), params.valueFormatted);
    }
    
    if(hideMe) {
      return `<div></div>`;
    }
    
    
    
    let scenConf: scenCellConfig = model.scenarioEngine.baseScenDetection(params);
    let result: string = ''; // rendu pour retour
    // console.log('CELL_SCEN_EDITABLE_RENDERER', params, params.valueFormatted);

    // rendre éditable (ou pas). Par défaut, ici, on est éditable
    // mais pas d'édition possible sur les filterKeys en row sur les lignes simples dans le cas d'une consolidation
    let showEdit: boolean = (params.colDef.widget as IWidget).checkBeforeEdit(params, false, true, true);
    let terminalDiv: boolean = true; // rajouter une div à la fin, pour les scenars

    if(scenConf.isScen && scenConf.hasDefault) {
      result = model.scenarioEngine.writeScenPart(scenConf.color, true);
      result += `<div style="position: relative; top: -60; width: calc(100% + 5px); height: 100%;">
      <div class="cell-edit-lbl-scen"> ${params.valueFormatted}</div>`;
    } else if(scenConf.isScen) {
      result = model.scenarioEngine.writeScenPart(scenConf.color, false);
      result += `<div style="position: relative; top: -30; width: calc(100% + 5px); height: 100%;">
      <div class="cell-edit-lbl-scen"> ${params.valueFormatted}</div>`;

    } else {
      terminalDiv = false;
      result = `<div class="cell-edit-lbl-noscen">${params.valueFormatted}</div>`
    }

    if(showEdit) {
      result += `<i class="wiz-icon- cell-edit-icon">edit</i>`;
    }
    if(terminalDiv) {
      result += `</div>`;
    }
    
    return result;
  }

  /** renderer des cellules éditables, hors cbx */
  public CBX_EDITABLE_RENDERER: ICellRendererFunc = (params: any) => {
    const model: Model = params.colDef.widget.model; // prise du modèle
    let scenConf: scenCellConfig =  model.scenarioEngine.baseScenDetection(params);
    let result: string = ''; // rendu pour retour

    
    let line: WidgetLine = params.data; // l'entrée de ligne    
    let hideMe: boolean = false; // masquer les checkBoxes qui n'existent pas
    if(!line.isTotalLine && !line.isSubTotalLine && params.colDef.widget?.pivotMode) {
      let realLinePack: WidgetLine[] = []; // le pool qu'on va gérer, si on est en mode pivot
      let col: any = params.columnApi.getColumn(params.colDef)?.parent;
      if(!!line.linesByColumn?.has(col)) { // on est en pivot, on prend seulement les lignes éligibles
        realLinePack = line.linesByColumn.get(col);
      } 
      if(realLinePack.length < 1) {
        hideMe = true;
      }
      // console.log('checkbox has data', line.key, line.linesByColumn.get(col), params.valueFormatted);
    }
    
    if(hideMe) {
      return `<div></div>`;
    }

    // interception des rendus "texte" sur les aggrégats de checkBox
    if(line.isTotalLine) {
      let colDef: WizColDef = params.colDef;
      if(!!colDef.wcio.totAgg) {
        let aggMethodDatakind: string = this.model.aggregateEngine.functionMap().get(colDef.wcio.totAgg).dataKind;
        if(aggMethodDatakind !== AggregateEngine.AGG_BOOLEAN) {
          // console.log('CBX_EDITABLE_RENDERER',aggMethodDatakind, params);
          return this.CELL_SCEN_EDITABLE_RENDERER(params);
        };
      } 
    }
    


    let checkLook: string;
    switch (WizBooleanUtils.stringToBoolean(params.valueFormatted)) {
      case WIZ_BOOLEAN.TRUE:
        checkLook = 'fa-square-check';
        break;
      case WIZ_BOOLEAN.FALSE:
        checkLook = 'fa-square';
        break;
      default:
        checkLook = 'fa-square-minus';
    }


    if(scenConf.isScen && scenConf.hasDefault) {
      // console.log('multiBox', params);
      result =  model.scenarioEngine.writeScenPart(scenConf.color, true);
      result += `<div style="position: relative; top: -45;">
                <i class="fa-regular ${checkLook} wiz-cell-bool"></i>
                </div>`;
    } else if(scenConf.isScen) {
      result =  model.scenarioEngine.writeScenPart(scenConf.color, false);
      result += `<div style="position: relative; top: -15;">
      <i class="fa-regular ${checkLook} wiz-cell-bool"></i>
      </div>`;

    } else {
      result =  `<i class="fa-regular ${checkLook} wiz-cell-bool"></i>`;
    }
    return result;
  }

  /** override des rendus des icones de suppression du pivot */
  public CELL_DELETION_SCEN_RENDERER(params: any) : string {
    let line: WidgetLine = params.data; // l'entrée de ligne  
    if(!!line.isTotalLine) {
      return `<div></div>`;
    }
    
    
    let widget: IWidget = (this as any).widget; // en fait, c'est appelé par wizAgGrid
    let result: string = ''; // rendu pour retour
    // prise de la vision
    let visionCode: string = widget?.vision?.code; 
 
    let scenConf: scenCellConfig = {};
    scenConf.isScen = false;
    scenConf.hasDefault = false;
    scenConf.useScen = !!widget?.context?.scenOn;
    // scenConf.useScen = !!params.colDef.widget.context?.scenOn;
    scenConf.color = StyleEngine.STYLE_DEFAULT_SCEN_COLOR;


    if(scenConf.useScen) { 
      let line: WidgetLine = params.data; // l'entrée de ligne    
      let realLinePack: WidgetLine[] = []; // le pool qu'on va gérer, si on est en mode pivot
      
      if(!!line.ch) { // on est en pivot, on prend les lignes
        realLinePack = [...line.ch.values()];
      } else {
        realLinePack = [line];
      }

      widget.model.scenarioEngine.baseScenDetection(params)
      realLinePack.forEach((wl: WidgetLine) => {
        if(wl.bl.scen !== ViewData.DEFAULT_SCENARIO) {
          scenConf.isScen = true; 
          scenConf.color =  widget.model.scenarioEngine.getScenario(visionCode, wl.bl.scen)?.color;
          return;
        }
      })
    }

    
    if(scenConf.isScen) {
      result =  widget.model.scenarioEngine.writeScenPart(scenConf.color, false);
      result += `<div class="wiz-cell-container"><i class="deletion-grid-cell"></i></div>`;
      // result += `<div style="position: relative; top: -30;">
      // <i class="deletion-grid-cell"></i>
      // </div>`;

    } else {
      // result =  `<i class="deletion-grid-cell"></i>`;
      result = `<div class="wiz-cell-container"><i class="deletion-grid-cell"></i></div>`;
    }
  
    return result;
  }

  public sortComparator(...args): number {
    console.log('sortComparator', args);
    return -1;
  }

  /** Gestion de rendu des images multiplesau sein du grid */
  public attachmentMultiCellRender(event: ICellRendererParams): string {
        
        // console.log("attachmentMultiCellRender", event.value, event.formatValue);
        // pas de valeurs
        if (!event.value) { 
          let result = `<div></div>`;
          return result;
        }

        // gestion des erreurs
        if(event.value === FunctionCoreEngine.FUNCTION_NOT_APPLICABLE 
        || event.value === FunctionCoreEngine.FUNCTION_ERROR 
        ) {
            return `<div></div>`;
        }

        let html = `<div class="wiz-cell-image-container" style='height:100%'>`;

        
        let cssStyle: string = (event.colDef as WizColDef).wcio?.sty;
        let injectClass: string = 'voidme';
        try {
          if(!!cssStyle) {
            injectClass = cssStyle;
          }
        } catch(e: any) {
          console.log('cssrender', e, cssStyle);
        }

        // const attachmentBlobId: string = event.valueFormatted?.replace(ViewData.KEY_SEPARATOR, '');
        const blobIds: string[] = event.valueFormatted?.split(ViewData.KEY_SEPARATOR);

        const missing: string[] = [];
        let baseHeight: string = '100%';
        if(blobIds?.length > 1) {
          baseHeight = '80%';
        }
        for (const blobId of blobIds) {
          const attachmentBytes: string = AttachmentService.getInstance().getAttachmentOrError(blobId, true);
          if (attachmentBytes === ViewData.ATTACHMENT_ERROR) { // la pièce est introuvable
            html += `<div></div>`; 
          } else if (attachmentBytes) {
            html += `<img class="wiz-cell-image thumb ${injectClass}" style="aspect-ratio: 1;

             height:${baseHeight}; max-width: unset; width: unset;" blobid='${blobId}' 
             src='${WizFileUtils.imageFromBinaryString(attachmentBytes)}'>`;
          } else {
            html+= `<div class="fa-xl" style="margin: 5px"><i class="fa-spin fa-solid fa-spinner"></i></div>`;
            missing.push(blobId);
          }
        }
        
        if(missing.length > 0) {
          const obs: Observable<string>[] = [];
          for (const blobId of missing) {
            obs.push(AttachmentService.getInstance().downloadAttachmentForWidget(blobId, true));
          }

          forkJoin(obs).subscribe(any => {
            // console.log('forkJoin result', any);
            event.api.refreshCells({ force: true, rowNodes: [event.node], columns: [event.column] });
          });
        }
        html += `</div>`;
        return html;
  }


}
